import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { Drawer, Input, Select, Button, Typography } from 'antd'
import { PROPOSAL_STATUS } from '../../utils/constants'
import { StyledSelect } from '../InternalDocumentIncoming/PopupHandleDocumentIncomingStyled'

const { Option } = Select

const SearchAdvance = ({
  openSearchAdvance,
  handleCloseSearchAdvance,
  filter,
  setFilter,
  proposalSalaryStore,
}) => {
  const [keyword, setKeyword] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')

  useEffect(() => {
    proposalSalaryStore.getProposalSalaryList(proposalSalaryStore.queryParams)
  }, [proposalSalaryStore.queryParams, proposalSalaryStore])

  const handleChangeStatus = value => {
    setSelectedStatus(value)
    proposalSalaryStore.setQueryParams('filterProposalStatus', value)
  }

  const handleApply = () => {
    proposalSalaryStore.setQueryParams('keyword', keyword)
    proposalSalaryStore.setQueryParams('filterProposalStatus', selectedStatus)
    setFilter({
      ...filter,
      page: 0,
      size: 10,
      keyword,
      proposal_status: selectedStatus,
    })
    handleCloseSearchAdvance()
  }

  const handleReset = () => {
    setKeyword('')
    setSelectedStatus('')
    proposalSalaryStore.setQueryParams('filterProposalStatus', '')
    proposalSalaryStore.setQueryParams('keyword', '')

    setFilter({
      page: 0,
      size: 10,
      type: 'PROPOSAL_SALARY',
      keyword: '',
      proposal_status: '',
    })
  }

  return (
    <Drawer
      title="Tìm kiếm nâng cao"
      placement="right"
      onClose={handleCloseSearchAdvance}
      open={openSearchAdvance}
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px 0',
          }}>
          <Button onClick={handleReset} type="default" style={{ width: '48%' }}>
            Nhập lại
          </Button>
          <Button onClick={handleApply} type="primary" style={{ width: '48%' }}>
            Áp dụng
          </Button>
        </div>
      }>
      <div style={{ padding: '10px 0' }}>
        <Typography className="font-semibold text-sm mb-2">Tìm kiếm</Typography>
        <Input
          placeholder="Tìm kiếm theo tiêu đề"
          value={keyword}
          onChange={e => setKeyword(e.target.value)}
          style={{ borderRadius: '5px', padding: '8px', marginBottom: '16px' }}
        />
        <Typography className="font-semibold text-sm mb-2">
          Lọc theo trạng thái
        </Typography>
        <StyledSelect
          placeholder="Lọc theo trạng thái"
          value={selectedStatus}
          onChange={handleChangeStatus}
          className="w-full">
          <Option value="">Chọn trạng thái</Option>
          <Option value={PROPOSAL_STATUS.PENDING}>Chờ phê duyệt</Option>
          <Option value={PROPOSAL_STATUS.APPROVAL}>Đã phê duyệt</Option>
          <Option value={PROPOSAL_STATUS.REJECT}>Từ chối</Option>
        </StyledSelect>
      </div>
    </Drawer>
  )
}

export default inject('proposalSalaryStore')(observer(SearchAdvance))
